import { User } from "../models/user.model";
import { BaseDto } from "./base/base.dto";
import { LocationDto } from "./location.dto";
import { SectorDto } from "./sector.dto";
import { ThirdPartyDto } from "./thirdParty.dto";

export class UserDto extends BaseDto<User> {
    public id: string = "";
    public username: string = "";
    public thirdParty: ThirdPartyDto = null;
    public language: string = "";
    public wording: string = "";
    public password: string = "";
    public company: { id: string } = { id: null };
    public profile: { id: string } = { id: null };
    public location: LocationDto = null;
    public sector: SectorDto = null;

    constructor() {
        super();
        this.thirdParty = new ThirdPartyDto();
        this.location = new LocationDto();
        this.sector = new LocationDto();
    }

    public static fromBody(body: any): UserDto {
        let user = new UserDto();

        user.id = "" + body.id;
        user.username = body.username;
        user.language = body.language;
        user.wording = body.wording;
        user.password = body.password;

        if (body.company) {
            user.company = body.company;
        }

        if (body.profile) {
            user.profile = body.profile;
        }

        if (body.thirdParty) {
            user.thirdParty = ThirdPartyDto.fromBody(body.thirdParty);
        }

        if (body.location) {
            user.location = LocationDto.fromBody(body.location);
        }

        if (body.sector) {
            user.sector = LocationDto.fromBody(body.sector);
        }

        return user;
    }

    static fromModel(user: User): UserDto {
        let userDto = new UserDto();

        userDto.id = user.id;
        userDto.username = user.username;
        userDto.language = user.language;
        userDto.wording = user.wording;
        userDto.password = user.password;
        userDto.company = user.company;
        userDto.profile = user.profile;

        if (user.thirdParty) {
            userDto.thirdParty = ThirdPartyDto.fromModel(user.thirdParty);
        }

        if (user.location) {
            userDto.location = LocationDto.fromModel(user.location);
        }
        if (user.sector) {
            userDto.sector = SectorDto.fromModel(user.sector);
        }

        return userDto;
    }

    public toBody(): any {
        const clone: any = { ...this };

        clone.thirdParty = this.thirdParty.toBody();
        clone.location = this.location.toBody();
        clone.sector = this.sector.toBody();

        return clone;
    }

    toModel(): User {
        let user = new User();

        user.id = this.id;
        user.username = this.username;
        user.language = this.language;
        user.wording = this.wording;
        user.password = this.password;
        user.company = this.company;
        user.profile = this.profile;

        user.thirdParty = this.thirdParty.toModel();
        user.location = this.location.toModel();
        user.sector = this.sector.toModel();

        return user;
    }
}
